<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top:20px;">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="stuName" placeholder="请输入学生名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="schoolName" placeholder="请输入学校名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="idCard" placeholder="请输入身份证号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="examinationTypeId" clearable placeholder="请选择考核类型" @change="typeChnage">
                        <el-option v-for="item in searchCertTypeList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="examinationGradeId" clearable placeholder="请选择考核等级">
                        <el-option v-for="item in searCertGradeList" :key="item.value" :label="item.lable"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getStudentResultInfo()">搜索</el-button>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>
                    <el-button type="primary" icon="el-icon-search" @click="ImportDialogVisible = true">导入</el-button>
                    <el-button type="primary" icon="el-icon-delete" @click="multiDeleteResult">删除</el-button>
                </el-form-item>
            </el-form>
        </header>

        <div style="padding-left:30px;">
            <el-table :data="list"  @selection-change="handleSelectionChange">
                <el-table-column prop="id" type="selection"></el-table-column>
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="studentName" label="学生姓名"></el-table-column>
                <el-table-column prop="idCard" label="身份证号"></el-table-column>
                <el-table-column prop="zkz_id" label="准考证号"></el-table-column>
                <el-table-column prop="examName" label="考核名称"></el-table-column>
                <el-table-column prop="examTime" label="考核时间"></el-table-column>
                <el-table-column prop="examinationGrade" label="考核等级"></el-table-column>
                <el-table-column prop="siteName" label="考核站点"></el-table-column>
                <el-table-column prop="qualifiedState" label="通过情况"></el-table-column>
                <el-table-column prop="certificateType" label="证书类型"></el-table-column>
                <el-table-column prop="score" label="考核成绩"></el-table-column>
                <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="u-page-con">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler"
                    :current-page="page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCount" v-show="totalCount > 0"
                    style="text-align: center;"></el-pagination>
            </div>
        </div>

        <el-dialog title="编辑" :append-to-body="true" :visible.sync="dialogFormVisible" width="800px">
            <el-form :inline="true" :model="from" class="demo-form-inline" label-width="120px">
                <el-form-item label="学生姓名">
                    <el-input v-model="from.studentName"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="from.idCard"></el-input>
                </el-form-item>
                <el-form-item label="考核名称">
                    <el-input v-model="from.examName"></el-input>
                </el-form-item>
                <el-form-item label="考核时间">
                    <el-date-picker type="date" placeholder="选择日期" v-model="from.examTime"
                        style="width: 100%;"></el-date-picker>
                </el-form-item>
                <!-- <el-form-item label="证书编号">
          <el-input v-model="from.certificateNum"></el-input>
        </el-form-item>
        <el-form-item label="发证时间">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="from.dateofIssue"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item> -->
                <el-form-item label="考核类型">
                    <el-select v-model="from.examinationTypeId" placeholder="请选择" @change="typeChnage">
                        <el-option v-for="item in certTypeList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考核等级">
                    <el-select v-model="from.examinationGradeId" placeholder="请选择">
                        <el-option v-for="item in certGradeList" :key="item.value" :label="item.lable"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考核站点">
                    <el-input v-model="from.siteName"></el-input>
                </el-form-item>
                <el-form-item v-show="from.examYMEnglish != ''" label="考核年月英文">
                    <el-input disabled v-model="from.examYMEnglish"></el-input>
                </el-form-item>
                <el-form-item v-show="from.examinationGradeEnglish != ''" label="考核等级英文">
                    <el-input disabled v-model="from.examinationGradeEnglish"></el-input>
                </el-form-item>
                <el-form-item v-show="from.studentNamePinyin != ''" label="学生名称拼音">
                    <el-input disabled v-model="from.studentNamePinyin"></el-input>
                </el-form-item>
                <el-form-item label="是否合格">
                    <el-radio-group v-model="from.qualifiedState">
                        <el-radio label="合格">合格</el-radio>
                        <el-radio label="不合格">不合格</el-radio>
                        <el-radio label="缺考">缺考</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="学生头像">
                    <imageUpload class="img_upload" :url="urlAliyunOSS" :files.sync="from.studentUrl"
                        v-if="dialogFormVisible" format="image"></imageUpload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="editInfo()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 导入 -->
        <!-- <el-dialog :before-close="cancel" title="Excel导入" :visible.sync="ImportDialogVisible" width="50%" top="3%" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" label-width="80px" size="mini" @submit.prevent="importFile">
            <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :file-list="fileList" :auto-upload="false" :on-success="onSuccess" accept="xls, xlsx" :limit="1" style="display: inline-block; text-align: center;margin-top:15px;">
                <el-button slot="trigger" type="primary">选取文件</el-button>
                <a style="color: #049cdb; text-decoration: underline;margin-left:15px;" href="/public/docs/考生成绩导入模板.xlsx">下载模板</a>
                <div slot="tip" class="el-upload__tip"></div>
            </el-upload>
            <p class="excelparaph" style="font-size:18px;margin:0px 0px 10px;">注意事项：</p>
            <ul class="attention_excel" style="font-size:16px;padding-left:40px;">
                <li>1.请按照模板规范顺序导入数据,确认表格数据是否填写完整</li>
            </ul>
            <el-table :data="errorList" v-show="errorList.length > 0" style="width: 100%">
                <el-table-column prop="stuName" label="行号" width="180"></el-table-column>
                <el-table-column prop="errorMsg" label="错误" style="width:80%"></el-table-column>
            </el-table>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="importFile()">确 定</el-button>
        </div>
    </el-dialog> -->
        <!-- 导入考生成绩 -->
        <el-dialog title="Excel批量导入考生成绩信息" :close-on-click-modal="false" :visible.sync="ImportDialogVisible"
            width="740px" class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="top-tip-con">
                    <div class="clearfix">
                        <span class="fl">操作提示：</span>
                        <div class="fl tip-article-con">
                            为了方便您的工作，我们已经准备好了《考生成绩信息导入》的标准模版，请您先下载考生成绩导入标准模版，填写后选择填写好的模版导入数据即可，
                            <span class="mark-tip">
                                为了能够准确的导入数据，请务必按照标准模版的要求进行填写。
                            </span>
                        </div>
                    </div>
                    <div class="download-model-con">
                        <a :href="wordUrl" class="el-link">
                            <el-button type="primary" class="download-model-btn">下载考生成绩信息导入模版</el-button>
                        </a>
                    </div>
                </div>
                <div class="import-table-con">
                    <p>
                        <i class="kz-icon-tishi"></i> 请选择要导入的考生成绩信息表格
                    </p>
                    <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :file-list="fileList"
                        :auto-upload="false" :on-success="onSuccess" accept="xls" :limit="1"
                        style="display: inline-block; text-align: center;margin-top:15px;">
                        <el-button slot="trigger" type="primary">选择导入文件</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
                    <!-- <el-button type="primary" class="select-impoort-file">选择导入文件</el-button> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ImportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="importFile">确定导入</el-button>
            </span>
        </el-dialog>
        <!-- 数据导入结果 -->
        <el-dialog title="数据导入结果" :visible.sync="dataResultVisible" width="740px" class="import-stu-info-dialog"
            :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <p>
                        <i class="kz-icon-tishi"></i> 您本次共导入{{ count }}条数据，导入结果如下
                    </p>
                    <div>
                        <div class="clearfix down-load-btn">
                            <span class="fl sp-import-num">导入成功：{{ successNum }}条</span>
                            <a v-if="successNum > 0" :href="successUploadFileUrl">
                                <el-button type="primary" class="fr">下载导入成功记录</el-button>
                            </a>
                        </div>
                        <div class="clearfix down-load-btn">
                            <span class="fl sp-import-num">导入失败：{{ failNum }}条</span>
                            <a v-if="failNum > 0" :href="failUploadFileUrl">
                                <el-button type="primary" class="fr download-model-btn">下载导入失败记录</el-button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dataResultVisible = false">取 消</el-button>
                <el-button type="primary" @click="dataResultVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 进度条 -->
        <el-dialog title="数据导入中。。。" :close-on-click-modal="true" :visible.sync="percentageVisible" width="740px"
            class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelImport">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 批量删除 -->
        <el-dialog :before-close="cancel" title="批量删除" :visible.sync="DeleteAllDialogVisible" width="30%" top="3%"
            :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form ref="form" label-width="120px" size="mini">
                <el-form-item label="开始时间">
                    <el-date-picker v-model="deleteStartTime" type="datetime" placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker v-model="deleteEndTime" type="datetime" placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDeleteAll">取 消</el-button>
                <el-button type="primary" @click="deleteAll()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            stuName: "",
            schoolName: "",
            idCard: "",
            examinationTypeId: "",
            examinationGradeId: "",
            list: [],
            from: {
                id: "",
                studentName: "",
                examName: "",
                examTime: "",
                examinationTypeId: "",
                examinationType: "",
                examinationGradeId: "",
                examinationGrade: "",
                siteName: "",
                idCard: "",
                qualifiedState: "合格",
                certificateNum: "",
                dateofIssue: "",
                examYMEnglish: "",
                examinationGradeEnglish: "",
                studentNamePinyin: "",
                studentUrl: ""
            },
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            //编辑信息
            dialogFormVisible: false,
            //导入
            ImportDialogVisible: false,
            uploadUrl: "/api/XOrg/ResultsManager/uploadExcelPro",
            fileList: [], //导入文件
            errorList: [], //错误信息
            certTypeList: [],
            certGradeList: [],
            certTypeId: '',
            searchCertTypeList: [],
            searCertGradeList: [],
            // 导入结果
            dataResultVisible: false,
            wordUrl: "/public/docs/考生成绩导入模板.xlsx",
            count: 0,
            successNum: 0,
            successFileName: "",
            failNum: 0,
            failFileName: "",
            // 批量删除
            DeleteAllDialogVisible: false,
            deleteStartTime: "",
            deleteEndTime: "",
            //
            percentageVisible: false,
            percentage: 0,
            taskId: "",
            timer: null,
            ids: []
        };
    },
    components: {
        imageUpload
    },
    computed: {
        failUploadFileUrl() {
            // return decodeURI("/api/Province/Major/uploadFile?filePath=" + this.failFileName);
            return decodeURI("/api/XOrg/ImportTask/uploadImportFile?id=" + this.taskId + "&type=2");
        },
        successUploadFileUrl() {
            // return decodeURI("/api/Province/Major/uploadFile?filePath=" + this.successFileName);
            return decodeURI("/api/XOrg/ImportTask/uploadImportFile?id=" + this.taskId + "&type=1");
        },
    },
    created() {
        this.getStudentResultInfo();
        this.getCertificateType();
        this.getSearchCertificateType();
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        "from.examinationTypeId": function (val) {
            this.getCertificateGrade();
        },
        // eslint-disable-next-line no-unused-vars
        "examinationTypeId": function (val) {
            this.getSearchCertificateGrade();
        },
    },
    methods: {
        deleteAll() {
            var that = this;
            this.$confirm("此操作将删除该时间段学生数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ResultsManager/deleteStudentResultAll", {
                        startTime: this.deleteStartTime,
                        endTime: this.deleteEndTime
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.DeleteAllDialogVisible = false;
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        // 取消进度条
        cancelImport() {
            var that = this;
            that.$http
                .post('/api/XOrg/ImportTask/cancelImport', {
                    id: that.taskId,
                })
                .then(function () {
                    that.percentageVisible = false;
                    clearInterval(that.timer);
                })
        },
        cancelDeleteAll() {
            this.DeleteAllDialogVisible = false;
            this.deleteStartTime = "";
            this.deleteEndTime = "";
        },
        getSearchCertificateType() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateTypeManager/getCertificateType")
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.searchCertTypeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getSearchCertificateGrade() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: this.examinationTypeId
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.searCertGradeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getCertificateType() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateTypeManager/getCertificateType")
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.certTypeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        typeChnage() {
            // this.getCertificateGrade();
            this.from.examinationGradeId = "";
        },
        getCertificateGrade() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: this.from.examinationTypeId
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.certGradeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancelInfo() {
            this.from.id = "";
            this.from.studentName = "";
            this.from.examName = "";
            this.from.examTime = "";
            this.from.examinationTypeId = "";
            this.from.examinationType = "";
            this.from.examinationGradeId = "";
            this.from.examinationGrade = "";
            this.from.siteName = "";
            this.from.idCard = "";
            this.from.qualifiedState = "";
            this.from.certificateNum = "";
            this.from.dateofIssue = "";
            this.from.examYMEnglish = "";
            this.from.examinationGradeEnglish = "";
            this.from.studentNamePinyin = "";
            this.from.studentUrl = "";
            this.dialogFormVisible = false;
        },
        onSuccess(res) {
            var that = this;
            if (res.code > 0) {
                this.ImportDialogVisible = false;
                this.percentageVisible = true;
                this.taskId = res.taskId;
                this.timer = setInterval(function () {
                    that.$http
                        .post('/api/XOrg/ImportTask/getImportProgress', {
                            id: res.taskId,
                        })
                        .then(function (rst) {
                            if (rst.code > 0) {
                                that.percentage = rst.info.progressBar;
                                if (that.percentage == 100) {
                                    clearInterval(that.timer);
                                    that.failNum = rst.info.failNumber;
                                    that.successNum = rst.info.successNumber;
                                    that.count = rst.info.importCount;
                                    that.dataResultVisible = true;
                                    that.percentageVisible = false;
                                    that.percentage = 0;
                                    that.page = 1;
                                    that.getStudentResultInfo();
                                }
                            } else {
                                that.$message.warning(rst.msg)
                            }
                        })
                }, 2000);
            } else {
                this.$message.warning(res.msg);
            }
            // if (res.code > 0) {
            //     this.ImportDialogVisible = false;
            //     this.fileList = [];
            //     this.dataResultVisible = true;
            //     this.count = res.info.count;
            //     this.successNum = res.info.successNum;
            //     this.successFileName = res.info.successFileName;
            //     this.failNum = res.info.failNum;
            //     this.failFileName = res.info.failFileName;
            //     this.getStudentResultInfo();
            // } else {
            //     this.fileList = [];
            //     this.$message.warning(res.msg);
            // }
        },
        //导入题库
        importFile() {
            this.$refs.upload.submit();
        },
        //清除数据
        cancel() {
            this.ImportDialogVisible = false;
            this.fileList = [];
        },
        addInfo() {
            this.dialogFormVisible = true;
        },
        //编辑
        editInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/ResultsManager/addOrEditStuResultInfo", {
                    id: this.from.id,
                    studentName: this.from.studentName,
                    examName: this.from.examName,
                    examTime: this.from.examTime,
                    examinationGradeId: this.from.examinationGradeId,
                    examinationTypeId: this.from.examinationTypeId,
                    siteName: this.from.siteName,
                    idCard: this.from.idCard,
                    qualifiedState: this.from.qualifiedState,
                    certificateNum: this.from.certificateNum,
                    dateofIssue: this.from.dateofIssue,
                    studentUrl: this.from.studentUrl
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getStudentResultInfo();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //弹出框赋值
        handleEdit(row) {
            this.from.id = row.id;
            this.from.studentName = row.studentName;
            this.from.examName = row.examName;
            this.from.examTime = row.examTime;
            this.from.examinationGradeId = row.examinationGradeId;
            this.from.examinationTypeId = row.certificateTypeId;
            this.from.siteName = row.siteName;
            this.from.idCard = row.idCard;
            this.from.qualifiedState = row.qualifiedState;
            this.from.certificateNum = row.certificateNum;
            this.from.dateofIssue = row.dateofIssue;
            this.from.examYMEnglish = row.examYMEnglish;
            this.from.examinationGradeEnglish = row.examinationGradeEnglish;
            this.from.studentNamePinyin = row.studentNamePinyin;
            this.from.studentUrl = row.studentUrl;
            this.dialogFormVisible = true;
        },
        handleSelectionChange(val) {
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.id);
            });
        },

        multiDeleteResult() {
            var that = this;
            var ids = this.ids;
            if (ids.length == 0) {
                that.$message.warning("请选择要删除的成绩数据");

                return;
            }

            this.$confirm("此操作将删除" + ids.length + "条成绩数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ResultsManager/deleteStudentResultInfo", {
                        ids: ids,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该学生数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ResultsManager/deleteStudentResultInfo", {
                        ids: id
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //查询
        getStudentResultInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/ResultsManager/getStudentResultInfo", {
                    studentName: this.stuName,
                    schoolName: this.schoolName,
                    idCard: this.idCard,
                    ExaminationGradeId: this.examinationGradeId,
                    CertificateTypeId: this.examinationTypeId,
                    PageSize: that.pageSize,
                    page: that.page
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getStudentResultInfo();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getStudentResultInfo();
        }
    }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }

}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2F7DFF;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1A2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #D8E0E6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #E65B72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #EE6C3A;
        border-color: #EE6C3A;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }

    .import-stu-info-dialog {
        .el-dialog__header {
            background: #2F7DFF;

            .el-dialog__title {
                color: #fff;
            }

            .el-dialog__headerbtn,
            .el-icon-close {
                color: #fff;
            }
        }

        .tip-info-main {
            margin: 20px 30px;
            color: #1A2638;
        }

        .top-tip-con {
            padding-bottom: 25px;
            border-bottom: 1px solid #D8E0E6;
        }

        .tip-article-con {
            margin-left: 10px;
            width: 550px;
            line-height: 1.5;

            .mark-tip {
                color: #E65B72;
            }
        }

        .download-model-con {
            margin-top: 29px;
            text-align: center;
        }

        .download-model-btn {
            background: #EE6C3A;
            border-color: #EE6C3A;
        }

        .import-table-con {
            padding-top: 20px;
            text-align: center;
        }

        .down-load-btn {
            margin-top: 25px;
        }

        .sp-import-num {
            margin-top: 6px;
        }

        .select-impoort-file {
            margin-top: 20px;
        }
    }
}
</style>
